import React from "react";
import { PAYMENT_METHOD_TYPE_ICON_MAP } from "components/PaymentMethodIcons";
import classnames from "classnames";
import Pill from "components/Pill";
import { UI_THEME } from "utils/constants/ui";
import { useIsAuthed } from "utils/selectors";
import { getStripeDestination } from "utils/stripe";
import { STRIPE_ROUTES } from "utils/constants/stripe";
import StripeExternalLink from "components/StripeExternalLink";

const PaymentMethodOption = ({
  innerProps,
  isDisabled,
  data,
  getStyles,
  ...props
}) => {
  const optionStyles = getStyles("option", props);
  const isAuthed = useIsAuthed();
  const TypeIcon = PAYMENT_METHOD_TYPE_ICON_MAP[data.value];

  return (
    <div
      {...innerProps}
      style={{
        ...innerProps.style,
        backgroundColor: optionStyles.backgroundColor
      }}
      className={classnames(
        "flex flex-column items-center pa2 bg-white--hover bb hairline-1",
        {
          "cursor-not-allowed": isDisabled
        }
      )}
    >
      <div className="flex flex-row items-center w-100">
        <div
          className="flex items-center justify-center"
          style={{ width: 32, height: 32 }}
        >
          {TypeIcon ? <TypeIcon /> : null}
        </div>
        <div className="flex flex-row items-center justify-between w-100">
          <div
            className={classnames("f5 pl2 w-100", {
              "color-text--secondary": isDisabled
            })}
          >
            {data.label}
          </div>
          {data.pill && (
            <div className="flex-shrink-0">
              <Pill theme={UI_THEME.SLIM} {...data.pill} />
            </div>
          )}
        </div>
      </div>
      {data.requestAccess && isAuthed && (
        <div className="w-100 flex flex-row items-end justify-end">
          <StripeExternalLink
            copy="Settings"
            customClasses={{
              link:
                "link__decoration--hover color-primary pointer link flex flex-row items-end f7 fw5"
            }}
            href={getStripeDestination({
              path: STRIPE_ROUTES.PAYMENT_METHODS,
              test: false
            })}
          />
        </div>
      )}
    </div>
  );
};

export default PaymentMethodOption;
